module.exports = __webpack_public_path__ + "static/banner-image-27bb2b4c4ac56d0572c00348a91917fb.png";